import { Flex } from "@mantine/core";

import { useDashboardOutstandingPrincipalAccumulative } from "../../../api/hooks/collectionDashboard/useDashboardOutstandingPrincipalAccumulative.ts";
import SectionTitle from "../../../components/Section/SectionTitle/SectionTitle.tsx";
import Table from "../../../components/Table/Table.tsx";
import { CollectionDashboardFilter } from "../types.ts";
import { useOutstandingPrincipalAccumulative } from "./hooks/useOutstandingPrincipalAccumulative.tsx";

interface Props {
  filter: CollectionDashboardFilter;
}

const OutstandingPrincipalAccumulative = ({ filter }: Props) => {
  const [{ data, fetching }] =
    useDashboardOutstandingPrincipalAccumulative(filter);

  const [columns, rows] = useOutstandingPrincipalAccumulative({
    data: data?.dashboardOutstandingPrincipalAccumulative,
  });

  return (
    <Flex direction="column" gap={12}>
      <SectionTitle>Outstanding Principal Accumulative</SectionTitle>
      <Table columns={columns} rows={rows} minWidth="100%" loading={fetching} />
    </Flex>
  );
};

export default OutstandingPrincipalAccumulative;
